export const environment = {
  production: false,
  googleMapsAPIKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  mapboxAPIKey: process.env.REACT_APP_MAPBOX_API_KEY,
  pusherCluster: 'mt1',
  pusherKey: process.env.REACT_APP_PUSHER_KEY,
  awsProjectRegion: 'us-east-1',
  awsCognitoRegion: 'us-east-1',
  awsCognitoIdentityPool: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL,
  awsUserPoolsId: process.env.REACT_APP_AWS_USER_POOLS_ID,
  awsUserPoolsWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  awsOauthDomain: 'gorilamx.auth.us-east-1.amazoncognito.com',
  awsOauthScope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
  awsOauthResponseType: 'code',
  awsAPIEndpointName: 'apiGorila',
  awsAPIEndpointUrl: process.env.REACT_APP_API_ENDPOINT_URL,
  awsChangePaswordApiEndpointName: 'changePasswordGorilaApi',
  awsOpenAPIEndpointName: 'apiGorilaOpen',
  awsAPICoreEndpointName: 'apiCore',
  awsAPICoreEndpointUrl: process.env.REACT_APP_API_CORE_ENDPOINT_URL,
  awsOpenAPIKey: process.env.REACT_APP_AWS_API_KEY,
  awsMediaS3Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
  awsMediaS3BucketRegion: 'us-east-1',
  awsNewMediaS3Bucket: process.env.REACT_APP_AWS_MONITORING_BUCKET_NAME,
  awsNewMediaS3BucketRegion: 'us-east-1',
  reportSettings: {
    routeEvent: {
      maxTimeInterval: 1, //value in months
    },
    positionHistory: {
      maxSeniorityTime: 6, //value in months
    },
  },
  datadogClientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  datadogSite: process.env.REACT_APP_DATADOG_SITE,
  datadogService: process.env.REACT_APP_DATADOG_SERVICE,
  datadogEnv: process.env.REACT_APP_DATADOG_ENV,
  // RUM
  rumRegion: 'us-east-1',
  rumIdentityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID,
  rumApplicationId: process.env.REACT_APP_RUM_APPLICATION_ID,
  rumVersion: process.env.REACT_APP_RUM_VERSION,
  // STREAMING
  mediaStream: process.env.REACT_APP_MEDIA_STREAM ?? 'flv',
  withLivePosters: process.env.REACT_APP_LIVE_POSTERS ?? 'disabled',
};
